// extracted by mini-css-extract-plugin
module.exports = {"stageClipApp":"appLayout_stageClipApp__1KULy","appContainerWrapper":"appLayout_appContainerWrapper__24sUv","appContainer":"appLayout_appContainer__2oK7c"};